import "../styles/Button.css";
import React, {ReactNode} from "react";

export enum ButtonType {
    CallToAction = "btn-cta",
    CallToActionLight = "btn-cta-light",
    Link = "btn-link",
    Primary = "btn-primary"
}
export enum ButtonSize {
    Large = "btn-lg",
    Medium = "btn-md",
    Small = "btn-sm"
}

export enum ButtonIcon {
    Coffee = 1,
    Figma = 2,
    UsTwo = 3,
    Calendar = 4,
    Mail = 5
}

interface ButtonProps {
    type                    : ButtonType,
    onClick                 : string | (() => void);
    icon?                   : ButtonIcon,
    secondContentIcon?      : ButtonIcon,
    classes?                : string[],
    border?                 : boolean,
    openInNewTab?           : boolean,
    disabled?               : boolean,
    nativeType?             : "button" | "submit" | "reset",
    children?               : ReactNode;
    secondContentChildren?  : ReactNode;
}

export const Button : React.FC<ButtonProps> = (props) => {
    function renderIcon() {
        switch (props.icon) {
            case ButtonIcon.Coffee:
                return IconCoffee();
            case ButtonIcon.Figma:
                return IconFigma();
            case ButtonIcon.UsTwo:
                return IconUsTwo();
            case ButtonIcon.Calendar:
                return IconCalendar();
            case ButtonIcon.Mail:
                return IconMail();
            default:
                return undefined;
        }
    }

    function renderBackground() {
        return props.border ? <div className={"background-color"}></div> : undefined
    }

    function renderContent() {
        const secondContentIcon = props.secondContentIcon ? props.secondContentIcon : props.secondContentChildren ? undefined : icon;
        const secondContentChildren = props.secondContentChildren ? props.secondContentChildren : props.children;
        return <div className={"content-wrapper"}>
            <div className={"content content-main"} key={"content"}>
                {icon}
                {icon ? <span>{props.children}</span> : props.children}
            </div>
            <div className={"content content-hovered"} key={"hovered-content"}>
                {
                    secondContentIcon
                }
                {secondContentIcon ? <span>{secondContentChildren}</span> : secondContentChildren}
            </div>
        </div>
    }

    const icon = renderIcon();
    if((props.type === ButtonType.Link && typeof props.onClick === "string") || (typeof props.onClick === "string" && props.nativeType !== "submit")) {
        return <a className={"button " + (props.border ? "border " : "") + props.type + ((props.classes && props.classes.length > 0) ? " " + props.classes.join(" ") : "" )} href={props.onClick} target={props.openInNewTab ? "_blank" : undefined}>
            {
                props.border ? renderBackground() : undefined
            }
            {renderContent()}
        </a>
    } else {
        return <button className={"button " + (props.border ? "border " : "") + props.type + ((props.classes && props.classes.length > 0) ? " " + props.classes.join(" ") : "" )} onClick={(props.nativeType === "submit" || typeof props.onClick === "string") ? undefined : props.onClick} disabled={props.disabled === true} type={props.nativeType || undefined}>
            {
                renderBackground()
            }
            {renderContent()}
        </button>
    }
}

function IconCoffee() {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.91666 7.71374H12.9167V14.3768C12.9167 14.8143 12.8304 15.2475 12.6629 15.6518C12.4954 16.0559 12.2499 16.4232 11.9403 16.7326C11.6308 17.0419 11.2633 17.2873 10.8589 17.4548C10.4545 17.6222 10.0211 17.7083 9.58333 17.7083H6.25C5.36594 17.7083 4.5181 17.3573 3.89297 16.7326C3.26786 16.1078 2.91666 15.2604 2.91666 14.3768V7.71374Z" stroke="#8000FF" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.9167 8.54659H15.4167C15.8587 8.54659 16.2826 8.72209 16.5952 9.03451C16.9077 9.34692 17.0833 9.77059 17.0833 10.2124V13.5439C17.0833 13.9857 16.9077 14.4094 16.5952 14.7218C16.2826 15.0342 15.8587 15.2097 15.4167 15.2097H12.8083" stroke="#8000FF" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.90833 5.6232C5.01818 5.51406 5.10537 5.38429 5.16486 5.24135C5.22434 5.09841 5.25497 4.94513 5.25497 4.79032C5.25497 4.63551 5.22434 4.48223 5.16486 4.33928C5.10537 4.19634 5.01818 4.06658 4.90833 3.95743C4.79847 3.84829 4.7113 3.71853 4.65181 3.57558C4.59232 3.43264 4.56169 3.27936 4.56169 3.12455C4.56169 2.96974 4.59232 2.81646 4.65181 2.67352C4.7113 2.53058 4.79847 2.40081 4.90833 2.29167" stroke="#8000FF" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.61667 5.6232C7.83651 5.40168 7.95986 5.10232 7.95986 4.79032C7.95986 4.47832 7.83651 4.17895 7.61667 3.95743C7.50681 3.84829 7.41964 3.71853 7.36014 3.57558C7.30065 3.43264 7.27003 3.27936 7.27003 3.12455C7.27003 2.96974 7.30065 2.81646 7.36014 2.67352C7.41964 2.53058 7.50681 2.40081 7.61667 2.29167" stroke="#8000FF" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.525 5.6232C10.6348 5.51406 10.722 5.38429 10.7815 5.24135C10.841 5.09841 10.8717 4.94513 10.8717 4.79032C10.8717 4.63551 10.841 4.48223 10.7815 4.33928C10.722 4.19634 10.6348 4.06658 10.525 3.95743C10.4152 3.84829 10.328 3.71853 10.2685 3.57558C10.209 3.43264 10.1783 3.27936 10.1783 3.12455C10.1783 2.96974 10.209 2.81646 10.2685 2.67352C10.328 2.53058 10.4152 2.40081 10.525 2.29167" stroke="#8000FF" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>;
}
function IconFigma() {
    return <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.13736 4.74836C9.53766 4.37058 9.81539 3.88137 9.93461 3.34402C10.0538 2.80668 10.0091 2.24591 9.8061 1.73429C9.60313 1.22266 9.25131 0.783711 8.79614 0.47423C8.34097 0.164749 7.8034 -0.0010235 7.25298 -0.00164032H2.75298C2.20257 -0.0010235 1.665 0.164749 1.20983 0.47423C0.75466 0.783711 0.402833 1.22266 0.199865 1.73429C-0.00310314 2.24591 -0.0478712 2.80668 0.0713524 3.34402C0.190576 3.88137 0.468305 4.37058 0.868608 4.74836C0.588962 5.01092 0.367479 5.32921 0.218454 5.68267C0.0694295 6.03613 -0.00382501 6.41691 0.00341904 6.80043C0.0106631 7.18395 0.0982447 7.56169 0.260511 7.90927C0.422777 8.25685 0.656122 8.56654 0.945483 8.81836C0.583602 9.15939 0.312167 9.58503 0.155591 10.057C-0.000984922 10.529 -0.0377905 11.0324 0.0484847 11.5221C0.13476 12.0119 0.34141 12.4724 0.649848 12.8625C0.958286 13.2525 1.35884 13.5598 1.81548 13.7566C2.27212 13.9534 2.77052 14.0337 3.26586 13.9901C3.7612 13.9465 4.23795 13.7805 4.65321 13.507C5.06848 13.2335 5.40924 12.861 5.64485 12.4231C5.88046 11.9852 6.00353 11.4956 6.00298 10.9984V9.19648C6.59209 9.49416 7.26861 9.57003 7.90902 9.41023C8.54943 9.25042 9.111 8.86562 9.49119 8.32607C9.87138 7.78652 10.0448 7.12823 9.97987 6.47139C9.91491 5.81455 9.61587 5.20298 9.13736 4.74836ZM8.50298 2.74836C8.50298 3.07988 8.37129 3.39782 8.13687 3.63224C7.90245 3.86666 7.5845 3.99836 7.25298 3.99836H6.00298V1.49836H7.25298C7.5845 1.49836 7.90245 1.63006 8.13687 1.86448C8.37129 2.0989 8.50298 2.41684 8.50298 2.74836ZM1.50298 2.74836C1.50298 2.41684 1.63468 2.0989 1.8691 1.86448C2.10352 1.63006 2.42146 1.49836 2.75298 1.49836H4.50298V3.99836H2.75298C2.42146 3.99836 2.10352 3.86666 1.8691 3.63224C1.63468 3.39782 1.50298 3.07988 1.50298 2.74836ZM2.75298 7.99836C2.42146 7.99836 2.10352 7.86666 1.8691 7.63224C1.63468 7.39782 1.50298 7.07988 1.50298 6.74836C1.50298 6.41684 1.63468 6.0989 1.8691 5.86448C2.10352 5.63006 2.42146 5.49836 2.75298 5.49836H4.50298V7.99836H2.75298ZM4.50298 10.9984C4.50298 11.295 4.41501 11.585 4.25019 11.8317C4.08537 12.0784 3.8511 12.2706 3.57701 12.3842C3.30292 12.4977 3.00132 12.5274 2.71035 12.4695C2.41938 12.4117 2.1521 12.2688 1.94232 12.059C1.73254 11.8492 1.58968 11.582 1.5318 11.291C1.47393 11 1.50363 10.6984 1.61716 10.4243C1.7307 10.1502 1.92295 9.91598 2.16963 9.75115C2.4163 9.58633 2.70631 9.49836 3.00298 9.49836H4.50298V10.9984ZM7.25298 7.99836C7.00576 7.99836 6.76408 7.92505 6.55852 7.7877C6.35296 7.65034 6.19274 7.45512 6.09813 7.22671C6.00352 6.99831 5.97877 6.74697 6.027 6.5045C6.07523 6.26202 6.19428 6.03929 6.3691 5.86448C6.54392 5.68966 6.76664 5.57061 7.00912 5.52238C7.2516 5.47415 7.50293 5.4989 7.73134 5.59351C7.95975 5.68812 8.15497 5.84834 8.29232 6.0539C8.42967 6.25946 8.50298 6.50113 8.50298 6.74836C8.50298 7.07988 8.37129 7.39782 8.13687 7.63224C7.90245 7.86666 7.5845 7.99836 7.25298 7.99836Z" fill="white"/>
    </svg>;
}
export function IconUsTwo() {
    return <img src={process.env.PUBLIC_URL + '/assets/us_two.png'} alt={"najsu code & design - Mária and Michal"} width={63} height={44}/>;
}
export function IconMail() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="52 42 88 66" width="16" height="16">
        <path fill="#4285f4" d="M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"/>
        <path fill="#34a853" d="M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"/>
        <path fill="#fbbc04" d="M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"/>
        <path fill="#ea4335" d="M72 74V48l24 18 24-18v26L96 92"/>
        <path fill="#c5221f" d="M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"/>
    </svg>;
}

export function IconCalendar() {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.224 3.4165H5.55729C4.08453 3.4165 2.89062 4.61041 2.89062 6.08317V11.9165C2.89062 13.3892 4.08453 14.5832 5.55729 14.5832H12.224C13.6967 14.5832 14.8906 13.3892 14.8906 11.9165V6.08317C14.8906 4.61041 13.6967 3.4165 12.224 3.4165Z"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.89062 7.4165H14.8906" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.2239 2.08301V4.74967" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5.55737 2.08301V4.74967" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}
export function IconTime() {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_717_4694" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="16"
              height="17">
            <path d="M15.5 1.0957V16.0957H0.5V1.0957H15.5Z" fill="white" stroke="white"/>
        </mask>
        <g mask="url(#mask0_717_4694)">
            <path d="M14.6668 8.59587C14.6668 12.2759 11.6802 15.2625 8.00016 15.2625C4.32016 15.2625 1.3335 12.2759 1.3335 8.59587C1.3335 4.91587 4.32016 1.9292 8.00016 1.9292C11.6802 1.9292 14.6668 4.91587 14.6668 8.59587Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.4734 10.7154L8.40675 9.48207C8.04675 9.26874 7.75342 8.7554 7.75342 8.3354V5.60205" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
    </svg>
}
export function IconCheck() {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_717_4739" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="16"
              height="16">
            <path d="M15.5 1.0957V16.0957H0.5V1.0957H15.5Z" fill="white" stroke="white"/>
        </mask>
        <g mask="url(#mask0_717_4739)">
            <path d="M6.00016 15.2625H10.0002C13.3335 15.2625 14.6668 13.9292 14.6668 10.5959V6.59587C14.6668 3.26253 13.3335 1.9292 10.0002 1.9292H6.00016C2.66683 1.9292 1.3335 3.26253 1.3335 6.59587V10.5959C1.3335 13.9292 2.66683 15.2625 6.00016 15.2625Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5.1665 8.59564L7.05317 10.4823L10.8332 6.70898" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
    </svg>
}
export function IconGoogleMeet() {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.8335 8.59584L10.1259 10.0731L11.8638 11.1716L12.1668 8.60568L11.8638 6.08447L10.0926 7.06023L8.8335 8.59584Z"
            fill="#188038"/>
        <path
            d="M1.3335 10.9443V13.1413C1.3335 13.6435 1.74031 14.0504 2.24259 14.0504H4.43956L4.8941 12.3897L4.43956 10.9443L2.93198 10.4897L1.3335 10.9443Z"
            fill="#1967D2"/>
        <path d="M4.43956 3.14111L1.3335 6.24717L2.93198 6.70172L4.43956 6.24717L4.88653 4.82066L4.43956 3.14111Z"
              fill="#EA4335"/>
        <path d="M1.3335 6.24707H4.43956V10.944H1.3335V6.24707Z" fill="#4285F4"/>
        <path
            d="M13.8479 4.45648L11.8638 6.08451V11.1716L13.8562 12.8663C14.1547 13.0997 14.591 12.8868 14.591 12.508V4.80799C14.591 4.4239 14.1448 4.2133 13.8479 4.45648Z"
            fill="#34A853"/>
        <path
            d="M8.83339 8.5957V10.9442H4.43945V14.0502H10.9546C11.4569 14.0502 11.8637 13.6434 11.8637 13.1412V11.1715L8.83339 8.5957Z"
            fill="#34A853"/>
        <path
            d="M10.9546 3.14111H4.43945V6.24717H8.83339V8.59566L11.8637 6.0843V4.0502C11.8637 3.54793 11.4569 3.14111 10.9546 3.14111Z"
            fill="#FBBC04"/>
    </svg>
}
export function IconGlobe() {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_717_4764)">
            <mask id="mask0_717_4764" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="0" y="0" width="16"
                  height="16">
                <path d="M16 0.595703H0V16.5957H16V0.595703Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_717_4764)">
                <path
                    d="M8.00016 15.2625C11.682 15.2625 14.6668 12.2777 14.6668 8.59587C14.6668 4.91397 11.682 1.9292 8.00016 1.9292C4.31826 1.9292 1.3335 4.91397 1.3335 8.59587C1.3335 12.2777 4.31826 15.2625 8.00016 15.2625Z"
                    stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M5.33372 2.5957H6.00039C4.70039 6.48904 4.70039 10.7024 6.00039 14.5957H5.33372"
                      stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 2.5957C11.3 6.48904 11.3 10.7024 10 14.5957" stroke="currentColor" strokeLinecap="round"
                      strokeLinejoin="round"/>
                <path d="M2 11.2624V10.5957C5.89333 11.8957 10.1067 11.8957 14 10.5957V11.2624" stroke="currentColor"
                      strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 6.59561C5.89333 5.29561 10.1067 5.29561 14 6.59561" stroke="currentColor" strokeLinecap="round"
                      strokeLinejoin="round"/>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_717_4764">
                <rect width="16" height="16" fill="white" transform="translate(0 0.595703)"/>
            </clipPath>
        </defs>
    </svg>
}
